export default "__VITE_ASSET__CxIHncfd__"